import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import { CategoryCheckGrid } from "@/components/MultiCategorySelect";

export function CategoryChips({ categories, selected, onToggle }) {
  return <CategoryCheckGrid options={categories} selected={selected} onToggle={onToggle} testId="pref" />;
}

export function PreferencesModal({ open, onOpenChange, categories, initial = [], onSaved }) {
  const { setUser } = useAuth();
  const [sel, setSel] = useState(initial);
  const [loading, setLoading] = useState(false);
  useEffect(() => { if (open) setSel(initial); }, [open]); // eslint-disable-line

  const toggle = (c) => setSel((s) => (s.includes(c) ? s.filter((x) => x !== c) : [...s, c]));

  const save = async () => {
    setLoading(true);
    try {
      const { data } = await api.put("/auth/preferences", { preferences: sel });
      setUser(data);
      toast.success("¡Listo! Personalizamos tus talleres recomendados.");
      onSaved?.(sel);
      onOpenChange(false);
    } catch {
      toast.error("No se pudieron guardar tus preferencias");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="preferences-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display">
            <Sparkles className="w-5 h-5 text-primary" /> ¿Qué talleres te interesan?
          </DialogTitle>
          <DialogDescription>
            Elige tus favoritos y te mostraremos ofertas relacionadas. Podrás ver todos cuando quieras.
          </DialogDescription>
        </DialogHeader>
        <CategoryChips categories={categories} selected={sel} onToggle={toggle} />
        <div className="flex gap-2 mt-4">
          <Button variant="ghost" className="flex-1" onClick={() => onOpenChange(false)} data-testid="pref-skip">
            Ahora no
          </Button>
          <Button className="flex-1" onClick={save} disabled={loading} data-testid="pref-save">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Guardar preferencias"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
